import React from "react";
import { Control, Controller } from "react-hook-form";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useMaxLengthValidation from "hooks/useMaxLengthValidation";

type TextAreaProps = {
  name: string;
  control: Control;
  label: string;
  rows?: number;
  disabled?: boolean;
  errors: any;
  maxLength?: number;
  required?: boolean;
  placeholder?: string;
};

const CustomTextArea: React.FC<TextAreaProps> = ({
  name,
  control,
  label,
  rows,
  disabled,
  errors,
  maxLength,
  required,
  placeholder = "",
}) => {
  const { t } = useTranslation();
  const { isMaxLengthReached, handleKeyDown } =
    useMaxLengthValidation(maxLength);

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required
          ? { value: true, message: t("validationRequired") }
          : undefined,
        maxLength: maxLength
          ? {
              value: maxLength,
              message: `${t("validationMaxLength")} ${maxLength}`,
            }
          : undefined,
      }}
      render={({ field: { onChange, value } }) => (
        <Form.Label className="text-area-report-details full-width-label">
          {label}
          <Form.Control
            as="textarea"
            rows={rows ?? rows}
            className="extra-lower-padding fixed-height"
            disabled={disabled}
            value={value ?? ""}
            maxLength={maxLength}
            onChange={(e) => {
              onChange(e);
            }}
            onKeyDown={handleKeyDown}
            required={required}
            placeholder={placeholder}
          />
          {isMaxLengthReached && (
            <span className="requiredField">
              {`${t("validationMaxLength")} ${maxLength}`}
            </span>
          )}
          {errors && errors?.message && (
            <span className="requiredField">*{errors.message}</span>
          )}
        </Form.Label>
      )}
    />
  );
};

export default CustomTextArea;
